"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOndemandTimeGaps = exports.submitTimesGaps = void 0;
var react_hot_toast_1 = require("react-hot-toast");
var api_service_1 = require("../../../api/api_service");
var submitTimesGaps = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .put({
            endPoint: api_service_1.api_service.api_urls.SYSTEM_CONFIG_UPDATE,
            domain: process.env.APPROVAL_BASEURL,
            showLoader: true,
            payLoad: payload,
        })
            .then(function (response) {
            if (response.status === 200) {
                resolve(response);
                react_hot_toast_1.default.success(response.data.message, {
                    duration: 2000,
                });
            }
            else {
                react_hot_toast_1.default.error(response.data.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.message);
            return reject(err);
        });
    });
};
exports.submitTimesGaps = submitTimesGaps;
var fetchOndemandTimeGaps = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: api_service_1.api_service.api_urls.SYSTEM_CONFIG_LIST,
            domain: process.env.APPROVAL_BASEURL,
            showLoader: true,
            payLoad: payload
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            var erroMessage = response.data
                ? response.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.message);
            return reject(err);
        });
    });
};
exports.fetchOndemandTimeGaps = fetchOndemandTimeGaps;
